import '../../style/';
import './index.less';
// import 'rc-dialog/assets/index.css';
